import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  createEnterpriseTagsRoute,
  errorMessage,
  enterpriseTagsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { tagsListKey } from '@features/enterprise/constants';

type useCreatetagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreatetags = ({
  setErrorText = () => {},
}: useCreatetagsProps) => {
  const client = useQueryClient();

  const { mutate: createTags, isLoading: isCreateTagsLoading } = useMutation({
    mutationFn: (variables: {
      tag: string;
      company_id?: number | string;
      template_id?: number;
    }) =>
      axiosInstance
        .post(createEnterpriseTagsRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([enterpriseTagsKey]);
        client.invalidateQueries([tagsListKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    createTags,
    isCreateTagsLoading,
  };
};
